import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';

import CustomTable from '../../../components/CustomTable';
import { APROBADO, REGISTRADO, ANULADO, RECHAZADO, IMPORTADO } from '../../../common/types/ordenCompraEstadoType';
import auth from "../../../common/utility/auth";
import global from '../../../common/utility/global';

export default function ResultList(props) {
    const renderColor = (row) => {
        if (row.idOrdenCompraEstado === REGISTRADO)
            return 'blue';
        if (row.idOrdenCompraEstado === APROBADO)
            return 'green';
        if (row.idOrdenCompraEstado === RECHAZADO)
            return 'orange';
        if (row.idOrdenCompraEstado === IMPORTADO)
            return 'gold';
        if (row.idOrdenCompraEstado === ANULADO)
            return 'red';
    };

    return (
        <CustomTable
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">

                            <Tooltip placement="top" title="Ver">
                                <Button
                                    type="primary"
                                    icon="search"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    onClick={() => props.onVer(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title="Editar">
                                <Button
                                    type="primary"
                                    icon="edit"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    onClick={() => props.onEditar(row)}
                                    disabled={row.idOrdenCompraEstado !== REGISTRADO ? true : false}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title="Anular">
                                <Button
                                    type="danger"
                                    icon="delete"
                                    size={"small"}
                                    onClick={() => props.onAnular(row)}
                                    disabled={row.idOrdenCompraEstado === REGISTRADO ? false : true}
                                />
                            </Tooltip>

                            <Tooltip placement="top" title="Aprobar">
                                <Button
                                    type="success"
                                    size={"small"}
                                    icon={"check"}
                                    onClick={() => props.onAprobar(row)}
                                    disabled={row.idOrdenCompraEstado === REGISTRADO ? false : true}
                                >
                                </Button>
                            </Tooltip>
                            <Tooltip placement="top" title="Rechazar">
                                <Button
                                    type="danger"
                                    icon="close"
                                    size={"small"}
                                    onClick={() => props.onRechazar(row)}
                                    disabled={row.idOrdenCompraEstado === REGISTRADO || row.idOrdenCompraEstado === APROBADO ? false : true}
                                />
                            </Tooltip>

                            <Tooltip placement="top" title="Imprimir">
                                <Button
                                    type="primary"
                                    icon="printer"
                                    size={"small"}
                                    loading={props.loadingPrint}

                                    onClick={() => props.onImprimir(row)}
                                />
                            </Tooltip>
                        </div>
                    )
                },
                {
                    title: 'Serie',
                    dataIndex: 'serie',
                    key: 'serie',
                    sorter: true
                },
                {
                    title: 'Documento',
                    dataIndex: 'documento',
                    key: 'documento',
                    sorter: true
                },
                {
                    title: 'Tipo Documento',
                    dataIndex: 'tipoDocumentoProveedor',
                    key: 'tipoDocumentoProveedor',
                    sorter: true
                },
                {
                    title: 'Número de Documento',
                    dataIndex: 'numeroDocumento',
                    key: 'numeroDocumento',
                    sorter: true
                },
                {
                    title: 'Proveedor',
                    dataIndex: 'razonSocial',
                    key: 'razonSocial',
                    sorter: true,
                    render: (value) => (
                        <div style={{ minWidth: "150px" }}>{value}</div>
                    )
                },
                {
                    title: 'Proyecto',
                    dataIndex: 'proyecto',
                    key: 'proyecto',
                    sorter: true
                },
                {
                    title: 'Fecha',
                    dataIndex: 'fechaStr',
                    key: 'fechaStr',
                    sorter: true
                },
                {
                    title: 'Moneda',
                    dataIndex: 'moneda',
                    key: 'moneda',
                    sorter: true
                },
                {
                    title: 'Total',
                    dataIndex: 'total',
                    key: 'total',
                    align: 'right',
                    sorter: true,
                    render: (value) => (
                        <span>{global.decimalFormat(value.toFixed(2))}</span>
                    )
                },
                {
                    title: 'Estado',
                    dataIndex: 'nombreOrdenCompraEstado',
                    key: 'nombreOrdenCompraEstado',
                    align: 'center',
                    width: "90px",
                    fixed: 'right',
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            <Tag color={renderColor(row)}>{value}</Tag>
                        </div>)
                    }
                }
            ]}
        />
    );

}

